// https://github.com/strapi/strapi/blob/develop/packages/core/admin/admin/src/content-manager/components/Wysiwyg/utils/mdRenderer.ts?open_in_browser=true
import hljs from "highlight.js"
import Markdown from "markdown-it"
import abbr from "markdown-it-abbr"
import container from "markdown-it-container"
import deflist from "markdown-it-deflist"
import emoji from "markdown-it-emoji"
import footnote from "markdown-it-footnote"
import ins from "markdown-it-ins"
import mark from "markdown-it-mark"
import sub from "markdown-it-sub"
import sup from "markdown-it-sup"
import { MARKDOWN_IMG_URL, IMG_URL } from "@lib/config"
import { getResponsiveImageUrl } from "@lib/util"

const createMd = (width) => {
  const md: Markdown = new Markdown({
    html: true, // Enable HTML tags in source
    xhtmlOut: false,
    breaks: true,
    langPrefix: "language-",
    linkify: true,
    typographer: true,
    // Code from: https://github.com/markdown-it/markdown-it/blob/master/support/demo_template/index.js#L83
    highlight(str, lang) {
      if (lang && lang !== "auto" && hljs.getLanguage(lang)) {
        return (
          '<pre class="hljs language-' +
          md.utils.escapeHtml(lang.toLowerCase()) +
          '"><code>' +
          hljs.highlight(lang, str, true).value +
          "</code></pre>"
        )
      }

      if (lang === "auto") {
        const result = hljs.highlightAuto(str)

        return (
          '<pre class="hljs language-' +
          md.utils.escapeHtml(result.language!) +
          '"><code>' +
          result.value +
          "</code></pre>"
        )
      }

      return (
        '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + "</code></pre>"
      )
    },
  })
    .use(abbr)
    .use(container, "warning")
    .use(container, "tip")
    .use(deflist)
    // .use(emoji)
    .use(footnote)
    .use(ins)
    .use(mark)
    .use(sub)
    .use(sup)

  // 自定义图片处理
  md.renderer.rules.image = (tokens, idx, options, env, self) => {
    const token = tokens[idx]
    let src = token.attrs![token.attrIndex("src")][1]
    const alt = token.content

    // 替换特定域名的图片 src
    const oldUrls = MARKDOWN_IMG_URL.split(",")
    const newUrl = IMG_URL

    oldUrls.forEach((oldUrl) => {
      if (src.includes(oldUrl)) {
        if (src.includes(".webp")) {
          src = src.replace(oldUrl, newUrl)
        } else {
          src = getResponsiveImageUrl(src.replace(oldUrl, newUrl), width)
        }
      }
    })
    return `<img src="${src}" alt="${alt}">`
  }

  md.renderer.rules.table_open = () => '<div class="table-container"><table>';
  md.renderer.rules.table_close = () => '</table></div>';

  md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
    const token = tokens[idx];
    token.attrPush(['target', '_blank']);
    token.attrPush(['rel', 'noopener noreferrer']);
    return self.renderToken(tokens, idx, options);
  };

  // Code from: https://github.com/markdown-it/markdown-it-footnote/blob/master/index.js#L29
  md.renderer.rules.footnote_ref = (tokens, idx, options, env, slf) => {
    const caption = slf.rules.footnote_caption?.(tokens, idx, options, env, slf)

    return '<sup class="footnote-ref"><span>' + caption + "</span></sup>"
  }

  md.renderer.rules.footnote_anchor = () => {
    /* ↩ with escape code to prevent display as Apple Emoji on iOS */
    return ' <span class="footnote-backref">\u21a9\uFE0E</span>'
  }
  return md
}

export { createMd }
